import React from 'react';
import styled from 'styled-components';
import { Body7 } from '@ui';
import { formatStatus } from './format';

// Maps a lifecycle status to the theme token used for its dot. Mirrors scoreBackfill/StatusBadge.
const DOT_TOKENS = {
  draft: 'secondaryText',
  locked: 'primaryCtaButton',
  approved: 'positive',
  retired: 'negative',
};

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  white-space: nowrap;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ theme, $token }) => theme.themeColors[$token] || theme.themeColors.secondaryText};
`;

export const SpecStatusBadge = ({ status }) => {
  const token = DOT_TOKENS[status] || 'secondaryText';
  return (
    <Pill>
      <Dot $token={token} />
      <Body7 bold>{formatStatus(status)}</Body7>
    </Pill>
  );
};

// Small "Live" indicator for the list/detail live_enabled column. Read from live_enabled only —
// never from spec_json (enabled_in / backfill_only are deprecated). Renders nothing when off.
export const LiveBadge = ({ live }) => {
  if (!live) return null;
  return (
    <Pill>
      <Dot $token="positive" />
      <Body7 bold>Live</Body7>
    </Pill>
  );
};
